document.addEventListener("DOMContentLoaded", () => {
  const tocBlocks = document.querySelectorAll(".toc-block-component")

  tocBlocks.forEach((tocBlock) => {

    /* =========================
       TOGGLE
    ========================== */

    const tocToggle = tocBlock.querySelector(".toc__toggle")
    const tocContent = tocBlock.querySelector(".toc__content")

    if (tocToggle && tocContent) {

      tocToggle.addEventListener("click", () => {

        const isOpen = tocBlock.classList.contains("open")

        if (isOpen) {
          tocContent.style.height = tocContent.scrollHeight + "px"

          requestAnimationFrame(() => {
            tocBlock.classList.remove("open")
            tocContent.style.height = "0px"
          })

        } else {
          tocBlock.classList.add("open")
          tocContent.style.height = tocContent.scrollHeight + "px"

          tocContent.addEventListener("transitionend", function handler(e) {
            if (e.propertyName === "height") {
              tocContent.style.height = "auto"
              tocContent.removeEventListener("transitionend", handler)
            }
          })
        }

        tocToggle.setAttribute("aria-expanded", !isOpen)
      })
    }

    /* =========================
       HIGHLIGHT
    ========================== */

    if (tocBlock.dataset.highlight !== "true") return

    const links = tocBlock.querySelectorAll(".toc__link")
    const headings = Array.from(links)
        .map(link => document.getElementById(link.dataset.target))
        .filter(Boolean)

    if (!headings.length) return

    function setActive(id) {
      links.forEach(link => {
        const isActive = link.dataset.target === id
        link.parentElement.classList.toggle("is-active", isActive)

        // Якщо це активний пункт — скролимо до нього всередині TOC
        if (isActive) {
          const scrollContainer = tocBlock.querySelector(".toc__list")
          if (scrollContainer) {
            const padding = 8
            const linkRect = link.getBoundingClientRect()
            const containerRect = scrollContainer.getBoundingClientRect()

            const linkTop = linkRect.top - containerRect.top
            const linkBottom = linkRect.bottom - containerRect.top

            if (linkTop < padding) {
              scrollContainer.scrollBy({ top: linkTop - padding, behavior: "smooth" })
            } else if (linkBottom > containerRect.height - padding) {
              scrollContainer.scrollBy({ top: linkBottom - containerRect.height + padding, behavior: "smooth" })
            }
          }
        }
      })
    }

    function clearActive() {
      links.forEach(link => {
        link.parentElement.classList.remove("is-active")
      })
    }

    function updateActive() {
      const viewportOffset = window.innerHeight * 0.3

      // Знаходимо всі хедінги, які вже проскролили (top <= viewportOffset)
      let current = null

      for (let i = headings.length - 1; i >= 0; i--) {
        const rect = headings[i].getBoundingClientRect()
        if (rect.top <= viewportOffset) {
          current = headings[i]
          break
        }
      }

      if (current) {
        setActive(current.id)
      } else {
        // Ще не доскролили до жодного хедінга — знімаємо всі
        clearActive()
      }
    }

    window.addEventListener("scroll", updateActive, { passive: true })
    window.addEventListener("resize", updateActive)

    updateActive()
  })
})
